import { render, staticRenderFns } from "./timelyComp.vue?vue&type=template&id=22d045e4&scoped=true&"
import script from "./timelyComp.vue?vue&type=script&lang=js&"
export * from "./timelyComp.vue?vue&type=script&lang=js&"
import style0 from "./timelyComp.vue?vue&type=style&index=0&id=22d045e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d045e4",
  null
  
)

export default component.exports